import React from 'react';

/**
 * Shared Accordion Section component for the "App" style views.
 * Used in ExecutionView, Wizard, and TemplatePreview to ensure a consistent look.
 */
const AccordionSection = ({ title, icon, isOpen, isComplete, children, className = '', onClick }) => {
    return (
        <div className={`rounded-lg border transition-all ${isComplete
            ? 'border-green-600/50 bg-green-900/10'
            : isOpen
                ? 'border-blue-600/50 bg-slate-800 shadow-lg'
                : 'border-slate-700 bg-slate-800/50'
            } ${className}`}>
            <div
                onClick={onClick}
                className={`p-3 md:p-4 flex items-center gap-3 cursor-pointer select-none hover:bg-slate-700/30 transition-colors ${isComplete ? 'text-green-400' : isOpen ? 'text-white' : 'text-slate-500'
                    }`}
            >
                <div className={`w-3 h-3 rounded-full shrink-0 ${isComplete ? 'bg-green-500' : isOpen ? 'bg-blue-500 animate-pulse' : 'bg-slate-600'
                    }`}></div>
                <div className="flex items-center gap-2 overflow-hidden">
                    {icon && <span className="shrink-0">{icon}</span>}
                    <span className="font-bold truncate text-sm md:text-base uppercase tracking-wider">{title}</span>
                </div>
                {isComplete && (
                    <div className="ml-auto flex items-center gap-1.5 bg-green-500/20 px-2 py-0.5 rounded-full border border-green-500/30">
                        <span className="text-[10px] font-black tracking-tighter uppercase whitespace-nowrap">✓ Voltooid</span>
                    </div>
                )}

                <div className={`ml-auto transition-transform duration-300 ${isOpen ? 'rotate-180' : ''} ${!isComplete ? 'opacity-50' : 'opacity-30'}`}>
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>
            {isOpen && (
                <div className="p-4 pt-0 md:p-6 md:pt-0 animate-slide-down">
                    {children}
                </div>
            )}
        </div>
    );
};

export default AccordionSection;
